import { GenPartial } from 'typeormgen';
import CmWrapBoxEpisodicItem from '../cm-wrap-box-episodic-items/cm-wrap-box-episodic-item.entity';

export interface CmWrapBoxEpisodicItemUpdateResponse {
	updated: {
		CmWrapBoxEpisodicItem?: GenPartial<CmWrapBoxEpisodicItem>[];
	};
}

export interface CmWrapBoxEpisodicItemUpdatePayload {
	cmWrapBoxEpisodicItems: GenPartial<CmWrapBoxEpisodicItem>[];
}
